import type { Base } from "./base";

export interface Integration extends Base {
  org: string;
  gym: string;
  type: IntegrationType;
  active: boolean;
  apiKey?: string;
  options: Record<string, any>;
}

export const IntegrationType = {
  helios: "helios",
  mindbody: "mindbody",
  shopify: "shopify",
  square: "square",
  tablelist: "tablelist",
  activeCampaign: "active-campaign",
  marianaTek: "mariana-tek",
  webhook: "webhook",
  fitdegree: "fitdegree",
  zenoti: "zenoti",
} as const;

export type IntegrationType = (typeof IntegrationType)[keyof typeof IntegrationType];

export interface IntegrationJob extends Base {
  integration: string;
  status: IntegrationJobStatus;
  type: IntegrationJobType;
  state: Record<string, any> | null;
}

export const IntegrationJobStatus = {
  queued: "queued",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

export type IntegrationJobStatus = (typeof IntegrationJobStatus)[keyof typeof IntegrationJobStatus];

export const IntegrationJobType = {
  shopifyClientIngest: "shopify_client_ingest",
  mindbodyClientIngest: "mindbody_client_ingest",
  marianaTekClientIngest: "mariana_tek_client_ingest",
  marianaTekSystemSetup: "mariana_tek_system_setup",
  marianaTekOrderIngest: "mariana_tek_order_ingest",
  activeCampaignClientIngest: "active_campaign_client_ingest",
  gymbleClientIngest: "gymble_client_ingest",
  tablelistClientIngest: "tablelist_client_ingest",
} as const;

export type IntegrationJobType = (typeof IntegrationJobType)[keyof typeof IntegrationJobType];
